// CareSuper join-flow brand tokens for signup v2 — a light-theme replica of
// Mark's reference screenshots of the real CareSuper join journey. This is a
// deliberate departure from the dark navy theme these same three ACUL
// screens used before (which matched the Member Portal's own dark login
// page) — the reference screenshots this rebuild is copying are light/white,
// with a distinct green + indigo palette, so these screens now intentionally
// look different from both the Member Portal's login page and the old
// signup theme. See ARCHITECTURE.md "Member Signup Flow" for the rationale.
//
// Call this AFTER applyAuth0Theme(...) in each screen so it always wins over
// the tenant's generic Universal Login branding.
const CARE_SUPER_GREEN = "#00A651";
const CARE_SUPER_GREEN_HOVER = "#008f45";
const CARE_SUPER_INDIGO = "#4A44F2";
const CARE_SUPER_INDIGO_HOVER = "#3d38cc";
const CARE_SUPER_NAVY = "#1D2B4F";

export function applyCareSuperBrand(): void {
  const root = document.documentElement.style;

  // Primary action colour is the indigo/violet from the reference
  // screenshots' pill buttons, not the green (green is reserved for the
  // stepper — see components/Stepper.tsx).
  root.setProperty("--ul-theme-color-primary-button", CARE_SUPER_INDIGO);
  root.setProperty("--ul-theme-color-primary-button-label", "#ffffff");
  root.setProperty("--ul-theme-color-base-focus-color", CARE_SUPER_INDIGO);
  root.setProperty("--ul-theme-color-base-hover-color", CARE_SUPER_INDIGO_HOVER);
  root.setProperty("--ul-theme-color-links-focused-components", CARE_SUPER_INDIGO);

  // Secondary ("outline") buttons — Back — white with an indigo border/label
  root.setProperty("--ul-theme-color-secondary-button-border", CARE_SUPER_INDIGO);
  root.setProperty("--ul-theme-color-secondary-button-label", CARE_SUPER_INDIGO);

  root.setProperty("--ul-theme-page-bg-background-color", "#ffffff");
  root.setProperty("--ul-theme-color-widget-background", "#ffffff");
  root.setProperty("--ul-theme-color-widget-border", "#E5E7EB");

  root.setProperty("--ul-theme-color-header", CARE_SUPER_NAVY);
  root.setProperty("--ul-theme-color-body-text", "#4B5563");
  root.setProperty("--ul-theme-color-input-labels-placeholders", "#6B7280");
  root.setProperty("--ul-theme-color-input-filled-text", CARE_SUPER_NAVY);
  root.setProperty("--ul-theme-color-input-border", "#D1D5DB");
  root.setProperty("--ul-theme-color-input-background", "#F9FAFB");

  // Pill-shaped buttons per the reference screenshots
  root.setProperty("--ul-theme-border-button-border-radius", "9999px");
  root.setProperty("--ul-theme-border-input-border-radius", "8px");
  root.setProperty("--ul-theme-border-widget-corner-radius", "16px");

  root.setProperty("--ul-theme-font-title-weight", "700");
}

// Exported for components that need the raw values outside CSS vars (e.g.
// the Stepper, which is styled with inline styles rather than theme tokens
// since it has no equivalent Universal Login theme concept).
export const CARE_SUPER_COLORS = {
  green: CARE_SUPER_GREEN,
  greenHover: CARE_SUPER_GREEN_HOVER,
  indigo: CARE_SUPER_INDIGO,
  indigoHover: CARE_SUPER_INDIGO_HOVER,
  navy: CARE_SUPER_NAVY,
  mint: "#E6F7F1",
};
